import React from "react";
import * as Icons from "lucide-react";
import { AUDIENCES, OWNER } from "../mock/mock";

export default function Audiences() {
  return (
    <section id="audiences" className="relative py-24 px-6 bg-forge-navy text-white overflow-hidden">
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.16] bg-cover bg-center"
        style={{ backgroundImage: `url(${OWNER.cymyran_exterior})` }}
      />
      <div className="absolute inset-0 bg-forge-navy/85" />

      <div className="relative max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <div className="text-[11px] tracking-[0.3em] uppercase text-forge-gold">Who We Welcome</div>
          <h2 className="font-serif text-4xl md:text-5xl mt-2">A comfortable stay, whatever brings you here</h2>
          <hr className="forge-divider" style={{ borderTopColor: "rgba(201,169,97,0.7)" }} />
          <p className="text-white/75 max-w-2xl mx-auto">
            From RAF Valley contractors on long-stay projects to families exploring Anglesey, every
            Forge Stays property is built around comfort, flexibility and a warm welcome.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {AUDIENCES.map((a) => {
            const Icon = Icons[a.icon] || Icons.Star;
            return (
              <article key={a.key} className="bg-white/[0.04] border border-white/10 p-8 backdrop-blur-sm hover:border-forge-gold transition-colors">
                <div className="w-12 h-12 rounded-full bg-forge-gold/15 border border-forge-gold/40 flex items-center justify-center mb-5">
                  <Icon size={20} className="text-forge-gold" strokeWidth={1.5} />
                </div>
                <h3 className="font-serif text-2xl">{a.title}</h3>
                <p className="text-white/75 text-sm leading-relaxed mt-3">{a.desc}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
